export enum SubModule {
    TELEPHONY = 'TELEPHONY',
}

export enum LogActionType {
    API_CALL = 'API_CALL',
    BTN_CLICK = 'BTN_CLICK',
    DEVICE_DETECTION_DEBUG = 'DEVICE_DETECTION_DEBUG',
    APP_MODE_RESOLVED = 'APP_MODE_RESOLVED',
    WIDGET_LOAD_TIME = 'WIDGET_LOAD_TIME',
    MESSAGE_SEND_INITIATED = 'MESSAGE_SEND_INITIATED',
    MESSAGE_SEND_FAILED = 'MESSAGE_SEND_FAILED',
    WEBSOCKET_MESSAGE = 'WEBSOCKET_MESSAGE',
    CORALOGIX_SDK_READY = 'CORALOGIX_SDK_READY',
    WIDGET_ENTRY_MOUNTED = 'WIDGET_ENTRY_MOUNTED',
    WIDGET_BRANCH = 'WIDGET_BRANCH',
    CURRENT_APP_CHANGED = 'CURRENT_APP_CHANGED',
    AUTH_MODE_EFFECT_RUN = 'AUTH_MODE_EFFECT_RUN',
    PLATFORM_START_HELPER_INVOKED = 'PLATFORM_START_HELPER_INVOKED',
    POSTMSG_START_CONVERSATION_RECEIVED = 'POSTMSG_START_CONVERSATION_RECEIVED',
    MARVIN_VCARD_CLICKED = 'MARVIN_VCARD_CLICKED',
    START_CONVERSATION_CALLED = 'START_CONVERSATION_CALLED',
    RECEIVED_CONTACT_OPEN_REQUEST = 'RECEIVED_CONTACT_OPEN_REQUEST',
    HOC_URL_PARAMS_READ = 'HOC_URL_PARAMS_READ',
    CONVERSE_IFRAME_START_CONVERSATION = 'CONVERSE_IFRAME_START_CONVERSATION',
    REDUX_CACHE_HYDRATED = 'REDUX_CACHE_HYDRATED',
    HANDLE_BACK_BUTTON = 'HANDLE_BACK_BUTTON',
    LEAD_OPENED_THROUGH_RC_SET = 'LEAD_OPENED_THROUGH_RC_SET',
    LOGGEDIN_USER_READY = 'LOGGEDIN_USER_READY',
    CHAT_HISTORY_RESET = 'CHAT_HISTORY_RESET',
    WEBVIEW_LIFECYCLE = 'WEBVIEW_LIFECYCLE',
}

export enum FailureType {
    UNHANDLED_REACT_ERROR = 'UNHANDLED_REACT_ERROR',
    API_ERROR = 'API_ERROR',
    NETWORK_ERROR = 'NETWORK_ERROR',
    WIDGET_INIT_ERROR = 'WIDGET_INIT_ERROR',
    MESSAGE_SEND_API_FAILED = 'MESSAGE_SEND_API_FAILED',
    MESSAGE_SEND_EXCEPTION = 'MESSAGE_SEND_EXCEPTION',
}
